import * as easing from './easing'

/**
 * アニメーションを実行する
 *
 * @param {Function} fn アニメーションコールバック (progress, percent) => {}
 * @param {Number} duration アニメーションの実行時間 ミリ秒
 * @param {Function} easingFn イージング関数
 * @returns {Promise} アニメーション終了を resolve で伝える Promise オブジェクトを返す
 */
export function tween (fn, duration, easingFn = easing.linear) {
  return new Promise(resolve => {
    let begin = 0

    const animate = now => {
      // 開始時刻を初期化する
      if (!begin) {
        begin = now
      }

      // 経過時間から移動量のパーセンテージを得る
      const percent = Math.min((now - begin) / duration, 1.0)

      // easing で進行度を算出する
      const progress = easingFn(percent)

      // コールバックでアニメーションに反映する
      fn(progress, percent)

      if (percent < 1) {
        requestAnimationFrame(animate)
      } else {
        resolve()
      }
    }

    requestAnimationFrame(animate)
  })
}
